import React from 'react';

interface ComparisonBarProps {
  rentValue: number;
  sellValue: number;
  formatCurrency: (value: number) => string;
}

export const ComparisonBar: React.FC<ComparisonBarProps> = ({
  rentValue,
  sellValue,
  formatCurrency
}) => {
  const maxValue = Math.max(rentValue, sellValue);
  const rentPercent = (rentValue / maxValue) * 100;
  const sellPercent = (sellValue / maxValue) * 100;
  const difference = rentValue - sellValue;
  const winner = difference > 0 ? 'rent' : 'sell';

  return (
    <div className="bg-white  border border-gray-200 p-6">
      <div className="space-y-4">
        {/* Rent bar */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Keep & Rent</span>
            <span className={`text-lg font-bold ${winner === 'rent' ? 'text-gray-900' : 'text-gray-700'}`}>
              {formatCurrency(rentValue)}
            </span>
          </div>
          <div className="h-4 bg-gray-100 overflow-hidden">
            <div
              className={`h-full transition-all duration-500 ${winner === 'rent' ? 'bg-gray-900' : 'bg-gray-400'}`}
              style={{ width: `${rentPercent}%` }}
            />
          </div>
        </div>

        {/* Sell bar */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Sell & Invest</span>
            <span className={`text-lg font-bold ${winner === 'sell' ? 'text-gray-900' : 'text-gray-700'}`}>
              {formatCurrency(sellValue)}
            </span>
          </div>
          <div className="h-4 bg-gray-100 overflow-hidden">
            <div
              className={`h-full transition-all duration-500 ${winner === 'sell' ? 'bg-gray-900' : 'bg-gray-400'}`}
              style={{ width: `${sellPercent}%` }}
            />
          </div>
        </div>
      </div>

      {/* Difference callout */}
      <div className="mt-6 p-4 bg-gray-50">
        <p className="text-center font-semibold text-gray-900">
          {winner === 'rent' ? 'Keep & Rent' : 'Sell & Invest'} comes out ahead by{' '}
          <span className="text-xl">{formatCurrency(Math.abs(difference))}</span>
        </p>
        <p className="text-center text-sm text-gray-600 mt-1">
          after 10 years (in today's dollars)
        </p>
      </div>
    </div>
  );
};

export default ComparisonBar;
